import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    notification: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px 16px',
        gap: '10px',
        borderRadius: '3px',
        fontFamily: "'Open Sans', sans-serif",
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '18px',
        textAlign: 'center',
    },
    message: {
        flex: 1,
        minWidth: 0,
        overflowWrap: 'break-word',
    },
    success: {
        backgroundColor: 'rgba(25, 170, 141, 0.17)',
        color: '#19AA8D',
    },
    error: {
        backgroundColor: 'rgba(247, 191, 192, 0.29)',
        color: '#EA6061',
    },
    warning: {
        backgroundColor: 'rgba(255, 199, 0, 0.17)',
        color: '#FFC700',
    },
    icon: {
        fontSize: '14px',
    },
})
